export default __webpack_public_path__ + "static/media/apprentice.cef2acb4.png";